import { Component } from "@angular/core";
import { faGem } from "@fortawesome/free-regular-svg-icons";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ShineAnimationModule } from "@animation-components";

@Component({
  selector: "app-diamond-icon",
  templateUrl: "./diamond-icon.component.html",
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, ShineAnimationModule],
  styleUrls: ["./diamond-icon.component.scss"],
})
export class DiamondIconComponent {
  faGem = faGem;
}
